import React from "react";
import styled from "styled-components";
import ErrorImg from "../assets/404.svg";
import Footer from "../components/Footer";
import MainNav from "../components/navbar/MainNav";
import Header from "../styles/Header";

export default function Page404() {
  return (
    <>
      <Header title="404" description="Page not found" />
      <Main>
        <img src={ErrorImg} alt="" />
      </Main>
    </>
  );
}

const Main = styled.div`
  margin: var(--section-margin) auto;
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    max-width: 500px;
    height: auto;
    margin: 4rem auto;
  }

  h4 {
    color: var(--primary-color);
  }
`;
